import TabNav from "./TabNav"
export default TabNav
